const GET_LIST = "infra/GET_LIST";
const GET_LIST_SUCCESS = "infra/GET_LIST_SUCCESS";
const GET_LIST_ERROR = "infra/GET_LIST_ERROR";
const SET_FILTERS = "infra/SET_FILTERS";
const SET_PAGINATION = "infra/SET_PAGINATION";

export default {
  GET_LIST,
  GET_LIST_SUCCESS,
  GET_LIST_ERROR,
  SET_FILTERS,
  SET_PAGINATION
};



// WEBPACK FOOTER //
// ./src/infraMonitor/types.js